export default "__VITE_ASSET__BynjT$FQ__"